<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/CRMange"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div class="content_title">
      <div class="d-flex">
        <div class="flex-item" style="width:30%;">
          <label class="label">Project Code</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="projectcodes"
            placeholder="Please input"
            type="textarea"
            rows="1"
          ></el-input>
        </div>
        <div class="flex-item">
          <el-button class="button-search" @click="addtransArgument()"
            >Add</el-button
          >
        </div>
        <div class="CR-btn">
          <el-button class="button-search" @click="nextStep()">Next</el-button>
        </div>
      </div>
      <div class="cr-add-table">       
        <div class="div-pagination">
          <el-pagination
            background
            @current-change="pagingChange"
            :current-page.sync="currentPage"
            @size-change="handleSizeChange"
            :page-size="pagenum"
            :page-sizes="[20, 30, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            ref="multipleTable"
          ></el-pagination>
        </div>
        <div class="table" ref="table" style="min-height: 500px">
          <el-table
            v-if="tableColumnNew.length > 0"
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            :height="tableHeight"
            border
            style="width: 100%"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <template>
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumnNew"
                :key="index"
                show-overflow-tooltip
                :width="
                  tableColumnNew.length > 6
                    ? flexColumnWidth(item.label, item.value)
                    : 'auto'
                "
                :fixed="fixColumn(index)"
                :formatter="rounding"
              >
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableColumn: [
        {
          label: "Project Code",
          value: "projectcode",
        },
        {
          label: "POS Name",
          value: "posFullNameCN",
        },
        {
          label: "Space",
          value: "space",
        },
        {
          label: "Support",
          value: "supportScheme",
        },
        {
          label: "Format",
          value: "format",
        },
      ],
      tableColumnNew: [],
      tableColumns: [],
      total: 0,
      pagenum: 20,
      loading: false,
      currentPage: 1,
      multipleSelection: [],
      IDs: [],
      projectcodes: "", //BWFNBHD-19-0253,BEAHCS-MegaL2(2.0)-20-0383
      clientHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
    };
  },
  computed: {
    tableHeight() {
      return this.clientHeight - 190 + "px";
    },
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleSizeChange(val) {
      this.pagenum = val;
      this.BindData(this.currentPage);
    },
    async BindData(pageIndex) {
      this.$route.params.ID;
      this.currentPage = pageIndex;
      this.loading = true;
      await this.$api
        .get("/CR/GetPLMCRProjectDetail/", {
          currentpage: pageIndex,
          pagenum: this.pagenum,
          ID: this.IDs.toString(),
        })
        .then((res) => {
          if (res.data.status == true) {
            this.tableData = res.data.content;
            this.total = res.data.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    async getNewtableCoumn() {
      this.tableColumnNew = [];
      if (this.tableData.length > 0) {
        let tmp = [];
        Object.keys(this.tableData[0]).forEach((e) => {
          this.tableColumns.forEach((d) => {
            if (e.toLowerCase() === d.toLowerCase()) {
              let obj = {
                label: d+'(w/ VAT)',
                value: e,
              };
              tmp.push(obj);
            }
          });
        });
        // console.log(tmp, "4444");
        if (tmp.length > 0) {
          this.tableColumnNew = [...this.tableColumn, ...tmp];
          // console.log(this.tableColumnNew , "6666");
        }
      } else {
        if (this.tableColumns.length > 0) {
          let tmp = this.tableColumns.map((c) => {
            return {
              label: c+'(w/ VAT)',
              value: c,
            };
          });
          this.tableColumnNew = [...this.tableColumn, ...tmp];
        }
      }
    },
    async GetCRMangeAddColumns() {
      // this.tableColumnNew = [];
      await this.$api.get("/CR/GetCRMangeAddColumns", {}).then((res) => {
        if (res.data.status === true) {
          // let tmp = res.data.content.map((c) => {
          //   return {
          //     label: c,
          //     value: c,
          //   };
          // });
          // if (!tmp.length) return;

          this.tableColumns = res.data.content;
        } else {
          if (res.data.message == "Login Error") {
            this.$router.push({ path: "/" });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        }
      });
    },
    getTableHeight() {
      window.addEventListener(
        "resize",
        () => {
          this.clientHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
        },
        true
      );
    },
    async Init() {
      await this.GetCRMangeAddColumns();
      let IDs = "";
      let obj = sessionStorage.getItem("Cr_Ids")
        ? JSON.parse(sessionStorage.getItem("Cr_Ids"))
        : null;
      if (this.$route.params.ID) {
        IDs = this.$route.params.ID;
      } else if (!!obj) {
        IDs = obj.ID;
      }
      this.IDs = IDs;
      await this.BindData(1);
      await this.getNewtableCoumn();
    },
    async addtransArgument() {
      await this.transArgument();
      await this.BindData(this.currentPage);
      await this.getNewtableCoumn();
      this.$nextTick(()=>{
              this.$refs.multipleTable.doLayout();
            })
    },
    async transArgument() {
      await this.$api
        .get("/CR/ReturnApplications/", {
          ids: this.IDs.toString(),
          projectcodes: this.projectcodes,
        })
        .then((res) => {
          if (res.data.status === true) {
            // this.$route.params.ID = res.data.content;
            if(res.data.content.length>0)
              this.IDs = res.data.content.split(",");
            else
              this.IDs=[];
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
        });
    },
    titleCase(str) {
      let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
      return newStr;
    },
    transferToDecimal(cellvalues) {
      if (!!cellvalues && typeof cellvalues === "number") {
        if (cellvalues > 0) {
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        }
      } else {
        return cellvalues;
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      const arr = this.tableData.map((x) => x[prop]);
      arr.push(label);
      return this.getMaxLength(arr) + 20 + "px";
    },
    getWidth(column) {
      return 9 * column.length + 10 + "px";
    },
    fixColumn(index) {
      if (index < 5) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      //console.log(val, "12");
      this.multipleSelection = val;
    },
    nextStep() {
      let applications =
        this.multipleSelection.map((c) => {
          return c.application;
        }) || [];
      if (!applications.length) {
        this.$message({
          type: "error",
          message: "至少选择一个",
        });
        return;
      }
      sessionStorage.setItem(
        "Cr_Add_Ids",
        JSON.stringify({ ID: applications })
      );
      this.$router.push({
        name: "CRAddSummary",
        params: {
          ID: applications,
        },
      });
    },
    rounding(row,column){
      let cellvalues = row[column.property];
      if (typeof(cellvalues)=="number") {
        cellvalues = parseFloat(cellvalues).toFixed(2);
        let [sInt, sFloat] = cellvalues.toString().split(".");
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
        return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
      }else
        return row[column.property];
    }
  },
  mounted() {
    this.Init();
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .CR-btn {
    flex: 1;
    display: flex;
    justify-content: end;
  }
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
}
.d-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin: auto;
  width: 94%;
  .flex-item {
    width: 25%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 10px;
    overflow: hidden;
    .label {
      padding-right: 5px;
      min-width: 120px;
      text-align: right;
    }
  }
}
.cr-add-table {
  width: 100%;

  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CRAdd.vue